/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BuildAndPrepareUserOpRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {BuildAndPrepareUserOpResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const buildAndPrepareUserOp = (request: BuildAndPrepareUserOpRequest, options?: CashRequestOptions) => post<BuildAndPrepareUserOpRequest, BuildAndPrepareUserOpResponse>("/2.0/cash/build-and-prepare-user-op", request, {...options, rejectOnError: true })